import { RelatedLP } from '../RelatedPages';
export default function Page() { return <RelatedLP slug="queens-butler" locale="ja" />; }
